import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { DocumentUpdate } from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-documents/models/document.model';
import { DirectorySubmit } from '@app/shared/models/employee/documents/directory-submit.model';
import { Directory } from '@app/shared/models/employee/documents/directory.model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {EnvironmentService} from "@app/core/services/environment.service";



const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class BenefitsPlanDocumentsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getDocuments(planId: string, folderId?: string): Observable<any> {
    let params = new HttpParams();
    folderId ? params = params.append('FolderId', folderId) : null;

    return this.http.get<any[]>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}`, {
      headers: headers,
      params: params
    });
  }

  getDocument(planId: string, documentId: string): Observable<any> {
    return this.http.get<any[]>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}`, {
      headers: headers
    });
  }

  deleteDocument(planId: string, documentId: string): Observable<any> {
    return this.http.delete<any[]>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}`, {
      headers: headers
    });
  }

  createDocument(planId: string, directory: DirectorySubmit): Observable<Directory> {
    return this.http.post<Directory>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}`, directory, {
      headers: headers
    });
  }

  updateDocument(planId: string, documentId: string, documentUpdate: DocumentUpdate): Observable<Directory> {
    return this.http.put<Directory>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}`, documentUpdate, {
      headers: headers
    });
  }

  uploadDocument(planId: string, file: File, name: string, parentId: string): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('File', file);
    formData.append('Parent', parentId ? parentId : '');
    formData.append('Comments', '');
    formData.append('Name', name ? name : '');

    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}`,
      formData,
      {
        headers: {},
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  getDocumentUrl(planId: string, documentId: string): Observable<any> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}/${api_routes.DOWNLOAD}`,
    {
      headers: headers,
      responseType: 'text' as 'json'
    }
    );
  }

  downloadDocument(planId: string, documentId: string): Observable<any> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}/${api_routes.DOWNLOAD}`,
    {
      headers: headers,
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  delete(planId: string, documentId: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.PLANS}/${planId}/${api_routes.DOCUMENTS}/${documentId}`, {
      headers: headers
    });
  }
}
